import { useState, useEffect } from "react";
import { useWeb3React } from '@web3-react/core';
import '../styles/style.css';
import { useSelector } from "react-redux";
import { ethers } from "ethers";

import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem, Divider } from "rc-menu";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import {Form} from "react-bootstrap";

import "rc-dropdown/assets/index.css";

export default function Dashboard(props) {
    const { connector, account, chainId, provider, active } = useWeb3React();

    const [isOpen, setIsOpen] = useState(false);
    const [headerFixed, setHeaderFixed] = useState("");
    const [amount, setAmount] = useState(0);
    const [minimalAmount, setMinimalAmount] = useState(0);
    const [sponsor, setSponsor] = useState("0x0586b1f23b48b83f35cf0f43b636067a4b8b0368");

    const [userSettings, setUserSettings] = useState({
        customer_login: "",
        first_name: "",
        last_name: "",
        phone: "",
        email: "",
        country: 4,
        city: "",
        avatar: "",
        isPushNots: false,
    });

    const { t, i18n } = useTranslation();

    const crowdsaleContract = useSelector(
        (state) => state.crowdsale.contract
    );
    const CrowdsaleAddress = useSelector(
        (state) => state.crowdsale.address
    );
    const tokenMyFrozen = useSelector((state) => state.crowdsale.tokenMyFrozen);
    const tokenPrice = useSelector((state) => state.crowdsale.tokenPrice);
    const tokenPriceBucks = useSelector(
        (state) => state.crowdsale.tokenPriceBucks
    );

    useEffect(() => {
        document.body.classList.remove('body-landing');

        if (localStorage.getItem("referralLink")) {
            let tmplink = localStorage.getItem("referralLink");
            tmplink.replace("https://bayon.io/link/", "").replace("/", "");

            setSponsor(tmplink);

            localStorage.removeItem("referralLink");
        }
    }, []);

    useEffect(() => {
        if (account != undefined) {

        }
    }, [account]);

    /**/useEffect(() => {

        if (!props.loading) {
            /*const getInfo = async () => {
                if (sponsor != '0x0000000000000000000000000000000000000000') {
                    localStorage.removeItem("referralLink");
                }
            }
            getInfo();
            let bnb_price = (tokenPrice / 100000000) * (tokenPriceBucks / 100000000);
            let minimal_bnb_amount = Math.round((10.5 / bnb_price) * 100000) / 100000;
            setMinimalAmount(minimal_bnb_amount);
            setAmount(minimal_bnb_amount);*/
        }
    }, [props.loading]);

    useEffect(() => {
        if (active === false) {
            window.location = "/";
        }
    }, [active]);

    const logoutHandler = async (event) => {
        //localStorage.setItem("provider", undefined);
        props.disconnect();
        localStorage.clear();
        window.location = '/';
    };

    let [isActiveMenu, setActiveMenu] = useState(false)
    function setActiveMenuHandler(isActive){
        setActiveMenu(isActive)
        if(isActive){
            document.body.classList.add('body-lock');
        }else{
            document.body.classList.remove('body-lock');
        }
    }

    const shortenAddress = (address) => {
        if (!address) {
            return false;
        }
        return `${address.slice(0, 6)}...${address.slice(
          address.length - 4,
          address.length
        )}`;
    }



    const menu = (
        <Menu onSelect={onSelect}>
            <MenuItem key="en">
                <a className="opHover" href="#">
                    <img src="img/flags/en.svg" alt="" />
                    <div className="lang">EN</div>
                </a>
            </MenuItem>
            <MenuItem key="uk">
                <a className="opHover" href="#">
                    <img src="img/flags/uk.svg" alt="" />
                    <div className="lang">UK</div>
                </a>
            </MenuItem>
            <MenuItem key="es">
                <a className="opHover" href="#">
                    <img src="img/flags/es.svg" alt="" />
                    <div className="lang">ES</div>
                </a>
            </MenuItem>
            <MenuItem key="it">
                <a className="opHover" href="#">
                    <img src="img/flags/it.svg" alt="" />
                    <div className="lang">IT</div>
                </a>
            </MenuItem>
            <MenuItem key="pt">
                <a className="opHover" href="#">
                    <img src="img/flags/pt.svg" alt="" />
                    <div className="lang">PT</div>
                </a>
            </MenuItem>
            <MenuItem key="fr">
                <a className="opHover" href="#">
                    <img src="img/flags/fr.svg" alt="" />
                    <div className="lang">FR</div>
                </a>
            </MenuItem>
            <MenuItem key="hu">
                <a className="opHover" href="#">
                    <img src="img/flags/hu.svg" alt="" />
                    <div className="lang">HU</div>
                </a>
            </MenuItem>
            <MenuItem key="de">
                <a className="opHover" href="#">
                    <img src="img/flags/de.svg" alt="" />
                    <div className="lang">DE</div>
                </a>
            </MenuItem>
            <MenuItem key="vi">
                <a className="opHover" href="#">
                    <img src="img/flags/vi.svg" alt="" />
                    <div className="lang">VI</div>
                </a>
            </MenuItem>
            <MenuItem key="tr">
                <a className="opHover" href="#">
                    <img src="img/flags/tr.svg" alt="" />
                    <div className="lang">TR</div>
                </a>
            </MenuItem>
            <MenuItem key="id">
                <a className="opHover" href="#">
                    <img src="img/flags/id.svg" alt="" />
                    <div className="lang">ID</div>
                </a>
            </MenuItem>
            <MenuItem key="zh">
                <a className="opHover" href="#">
                    <img src="img/flags/zh.svg" alt="" />
                    <div className="lang">ZH</div>
                </a>
            </MenuItem>
            <MenuItem key="kr">
                <a className="opHover" href="#">
                    <img src="img/flags/kr.svg" alt="" />
                    <div className="lang">KR</div>
                </a>
            </MenuItem>
            <MenuItem key="jp">
                <a className="opHover" href="#">
                    <img src="img/flags/jp.svg" alt="" />
                    <div className="lang">JP</div>
                </a>
            </MenuItem>
            <MenuItem key="pl">
                <a className="opHover" href="#">
                    <img src="img/flags/pl.jpg" alt="" />
                    <div className="lang">PL</div>
                </a>
            </MenuItem>
            <MenuItem key="ru">
                <a className="opHover" href="#">
                    <img src="img/flags/ru.svg" alt="" />
                    <div className="lang">RU</div>
                </a>
            </MenuItem>
        </Menu>
    );
    const [contLocale, setContLocale] = useState("");

    function onSelect({ key }) {
        i18n.changeLanguage(key);
        setContLocale(key);
        // console.log(key);
    }

    const buyTokens = async () => {
        try {
            let isActiveSponsor = await crowdsaleContract.referral_tree(
                sponsor
            );
            /*if (
                isActiveSponsor == "0x0000000000000000000000000000000000000000"
            ) {
                swal("Your sponsor did not activate his referral link");
                return;
            }*/

            if (amount <= 0) {
                swal("Value should be more than 0");
                return;
            }
            //let valueToSend = ethers.utils.parseUnits(amount.toString(), "ether");

            const options = { value: ethers.utils.parseEther(amount) };
            await crowdsaleContract.buyTokens(account, sponsor, options);
        } catch (error) {
            let errore = error.toString();
            let message = "";
            if (errore.indexOf("Internal JSON-RPC error.") > -1) {
                // console.log(errore);
                errore = errore
                    .replace("\n", "")
                    .replace("Error: ", "")
                    .replace("Internal JSON-RPC error.", "");
                errore = JSON.parse(errore);
                if (errore.message) {
                    message = errore.message;
                } else {
                    message = error;
                }
            } else {
                if (
                    typeof error === "object" &&
                    !Array.isArray(error) &&
                    error !== null
                ) {
                    if (error.message) {
                        message = error.message;
                    } else {
                        message = JSON.stringify(error);
                    }
                } else {
                    message = error;
                }
            }
            swal(message);
        }
    }

    const [isShowLeftMenu, setIsShowLeftMenu] = useState(false)

    let bnb_price = (tokenPrice / 100000000) * (tokenPriceBucks / 100000000);
    let minimal_bnb_amount = Math.round((10.5 / bnb_price) * 100000) / 100000;
    
    return (
        <>
            <div className="wrapper">
                <header className="landing_header">
                    <div className="container">
                        <div className="header_wrapper">
                            <div className="logo"><img src="/images/logo.png" /></div>
                            <div className="topmenu">
                                <ul>
                                    <li onClick={(e) => {
                                e.preventDefault();
                                navigator.clipboard.writeText("https://bayon.io/link/" + account );
                                swal("Done!");
                            }}><a href="#">Your link: <span>https://bayon.io/link/{account}</span></a></li>
                                </ul>
                            </div>
                            <div className="wallet">
                                <a
                                    className="opHover"
                                    href="#"
                                    onClick={() => { logoutHandler(); }}
                                >
                                    <div className="connectButton">
                                        Logout
                                    </div>                                                                
                                </a>
                            </div>
                        </div>
                    </div>
                </header>
                <main className="page">
                    <section className="firstBlock">
                        <div className="container">
                            <div className="balance">
                                <h1>You have: <span>{tokenMyFrozen} BAY</span></h1>
                            </div>
                            <div className="buyAmount">
                                <Form>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Enter bnb amount (min {minimal_bnb_amount})</Form.Label>
                                        <Form.Control type="text" className="tokenAmount" placeholder={minimal_bnb_amount} value={amount ? amount : minimal_bnb_amount} onChange={(e) =>
                                                setAmount(e.target.value)
                                        } />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                        <Form.Label>Your sponsor</Form.Label>
                                        <Form.Control type="text" className="tokenAmount" placeholder="100" value={sponsor} onChange={(e) =>
                                                setSponsor(e.target.value)
                                        } />
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                        <button className="btn btn-success" onClick={(e)=> {e.preventDefault(); buyTokens()}}>Buy</button>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
}